var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 178",
    style: {
      enableBackground: "new 0 0 500 178"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n\t.st1{fill:#1B9DD9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,177.8h-3V171L0,160.6h3.2l4.7,7.8l4.7-7.8h3.2L9.3,171L9.4,177.8L9.4,177.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,175.4c-1.7,1.7-3.9,2.6-6.5,2.6s-4.7-0.8-6.5-2.6c-1.7-1.7-2.6-3.8-2.6-6.4s0.9-4.7,2.6-6.4 c1.7-1.7,3.9-2.6,6.5-2.6s4.7,0.8,6.5,2.6c1.7,1.7,2.6,3.8,2.6,6.4S38.6,173.7,36.8,175.4z M34.7,164.6c-1.2-1.2-2.6-1.8-4.3-1.8 c-1.7,0-3.2,0.6-4.3,1.8c-1.2,1.2-1.8,2.7-1.8,4.4s0.6,3.2,1.8,4.4c1.2,1.2,2.6,1.8,4.3,1.8s3.2-0.6,4.3-1.8s1.8-2.7,1.8-4.4 C36.5,167.3,35.9,165.8,34.7,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52,173.9c0.8,0.9,1.9,1.4,3.2,1.4c1.4,0,2.4-0.5,3.2-1.4c0.8-0.9,1.2-2.2,1.2-3.7v-9.6h2.9v9.7 c0,2.5-0.7,4.4-2.1,5.7c-1.4,1.4-3.1,2-5.3,2s-3.9-0.7-5.3-2c-1.4-1.4-2.1-3.3-2.1-5.7v-9.7h2.9v9.6 C50.8,171.7,51.2,172.9,52,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6,175.2c1,0,1.9-0.2,2.6-0.5c0.7-0.3,1.5-0.9,2.3-1.6l1.9,1.9c-1.8,2-4.1,3-6.7,3s-4.8-0.8-6.5-2.5 c-1.7-1.7-2.6-3.8-2.6-6.4s0.9-4.7,2.6-6.4c1.8-1.7,4-2.6,6.6-2.6s4.9,1,6.7,3l-1.9,2c-0.8-0.8-1.6-1.4-2.3-1.6 c-0.7-0.3-1.6-0.5-2.6-0.5c-1.7,0-3.2,0.6-4.4,1.7c-1.2,1.1-1.8,2.6-1.8,4.3c0,1.8,0.6,3.2,1.8,4.4 C88.6,174.6,90,175.2,91.6,175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.3,173.9l-1.7,3.9h-3.1l7.6-17.3h3.1l7.6,17.3h-3.1l-1.7-3.9H109.3z M116.8,171.2l-3.1-7.1l-3.1,7.1 H116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.1,160.6h2.9v17.3h-3.2l-9.8-12.6v12.6h-2.9v-17.3h2.9l10,12.9L143.1,160.6L143.1,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175,177.8h-7.6v-17.3h6.7c1.2,0,2.2,0.1,3,0.4s1.5,0.7,1.9,1.1c0.8,0.9,1.2,1.9,1.2,3c0,1.4-0.4,2.3-1.3,3 c-0.3,0.2-0.5,0.4-0.7,0.4c-0.1,0-0.3,0.1-0.6,0.3c1.1,0.2,1.9,0.7,2.6,1.4c0.7,0.7,0.9,1.6,0.9,2.7c0,1.2-0.4,2.3-1.2,3.2 C179,177.3,177.4,177.8,175,177.8z M170.4,167.7h3.7c2.1,0,3.2-0.7,3.2-2.1c0-0.8-0.2-1.4-0.7-1.8c-0.5-0.4-1.3-0.6-2.4-0.6h-3.7 L170.4,167.7L170.4,167.7z M170.4,175.1h4.6c1.1,0,1.9-0.2,2.5-0.5c0.6-0.3,0.8-1,0.8-1.9c0-1.5-1.2-2.3-3.7-2.3h-4.2L170.4,175.1 L170.4,175.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202,160.6v2.8h-9.2v4.6h8.3v2.6h-8.3v4.6h9.5v2.8h-12.4v-17.3L202,160.6L202,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.1,173l3.9-12.4h2.6l3.9,12.4l4.3-12.4h3.1l-6,17.3H237l-3.6-11.8h-0.2l-3.6,11.8h-2.9l-6-17.3h3.1 L228.1,173z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.5,177.8v-17.3h2.9v7.5h8.6v-7.5h2.9v17.3H265v-7.1h-8.6v7.1H253.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.1,173.9l-1.7,3.9h-3.1l7.6-17.3h3.1l7.6,17.3h-3.1l-1.7-3.9H280.1z M287.6,171.2l-3.1-7.1l-3.1,7.1 H287.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.1,163.2v14.6h-2.9v-14.6h-5.3v-2.7h13.4v2.7H306.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338,177.8h-3V171l-6.4-10.5h3.2l4.7,7.8l4.7-7.8h3.2l-6.4,10.5L338,177.8L338,177.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.4,175.4c-1.7,1.7-3.9,2.6-6.5,2.6c-2.6,0-4.7-0.8-6.5-2.6c-1.7-1.7-2.6-3.8-2.6-6.4s0.9-4.7,2.6-6.4 c1.7-1.7,3.9-2.6,6.5-2.6c2.6,0,4.7,0.8,6.5,2.6c1.7,1.7,2.6,3.8,2.6,6.4S367.2,173.7,365.4,175.4z M363.3,164.6 c-1.2-1.2-2.6-1.8-4.3-1.8s-3.2,0.6-4.3,1.8c-1.2,1.2-1.8,2.7-1.8,4.4s0.6,3.2,1.8,4.4c1.2,1.2,2.6,1.8,4.3,1.8s3.2-0.6,4.3-1.8 s1.8-2.7,1.8-4.4S364.5,165.8,363.3,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.6,173.9c0.8,0.9,1.9,1.4,3.2,1.4s2.4-0.5,3.2-1.4c0.8-0.9,1.2-2.2,1.2-3.7v-9.6h2.9v9.7 c0,2.5-0.7,4.4-2.1,5.7c-1.4,1.4-3.1,2-5.3,2c-2.1,0-3.9-0.7-5.3-2c-1.4-1.4-2.1-3.3-2.1-5.7v-9.7h2.9v9.6 C379.4,171.7,379.8,172.9,380.6,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417.7,173l3.9-12.4h2.6L428,173l4.3-12.4h3.1l-6,17.3h-2.9L423,166h-0.2l-3.6,11.8h-2.9l-6-17.3h3.1 L417.7,173z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.2,160.6h2.9v17.3h-2.9V160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M461,162.8c-0.8,0-1.5,0.2-2.1,0.5c-0.6,0.3-0.8,0.9-0.8,1.6s0.3,1.2,0.8,1.6c0.6,0.4,1.7,0.8,3.5,1.2 c1.8,0.4,3.1,1,4,1.8c0.9,0.8,1.4,1.9,1.4,3.4s-0.6,2.7-1.7,3.7c-1.2,1-2.6,1.4-4.5,1.4c-2.7,0-5.1-0.9-7.2-2.8l1.8-2.2 c1.7,1.5,3.5,2.3,5.4,2.3c0.9,0,1.7-0.2,2.2-0.6s0.8-0.9,0.8-1.6c0-0.7-0.3-1.2-0.8-1.5c-0.5-0.4-1.4-0.7-2.7-1 c-1.3-0.3-2.2-0.6-2.9-0.8c-0.7-0.2-1.3-0.6-1.8-1c-1-0.8-1.5-2-1.5-3.5s0.6-2.8,1.7-3.7c1.2-0.9,2.6-1.3,4.3-1.3 c1.1,0,2.2,0.2,3.3,0.6c1.1,0.4,2,0.9,2.8,1.5l-1.5,2.2c-0.5-0.5-1.2-0.8-2.1-1.1C462.7,162.9,461.9,162.8,461,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M476.3,177.8v-17.3h2.9v7.5h8.6v-7.5h2.9v17.3h-2.9v-7.1h-8.6v7.1H476.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "195.2,100.4 177.3,5.6 150.9,5.6 106.3,100.4 90.7,6 57.8,6 85.7,146.4 112.4,146.4 156.7,55.2  175.4,146.4 202.1,146.4 269.5,6 237.4,6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.8,80.9c-11-4-20.8-6.8-19.9-12.7l0-0.4c0.6-4.2,4.8-7.4,12.2-7.4c7.8,0,17.8,3.8,27.5,9.9l14.5-20.9 C382.6,41.6,368.5,37,355,37c-21.5,0-40.8,12.1-43.8,33.9l0,0.4c-2.9,20.7,13,27.7,27.4,32.1c11.3,3.6,21.3,5.8,20.4,12.4l0,0.4 c-0.7,4.8-5.1,8-13.9,8c-9.9,0-21.5-4.4-31.9-12.7l-15.7,19.9c12.6,11.2,28.6,16.2,43.6,16.2c23.1,0,42.4-10.7,45.7-34.5l0-0.4 C389.4,93.1,373.1,85.9,358.8,80.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M468.7,36.7c-15.4,0-25.5,8.2-33.7,17.1L442.5,0h-30.3l-20.4,145.5h30.3l8.4-59.6c2-14.3,10.4-21.7,22-21.7 c11.6,0,17.3,7.4,15.3,21.7l-8.4,59.6h30.3l9.7-69.2C502.8,51.8,491.6,36.7,468.7,36.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "272.1,29.6 304.6,29.6 307.9,5.6 275.4,5.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "260.4,112.2 279.7,98 292.8,113.2 303.1,39.8 270.6,39.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "272,145.5 288.5,121.8 262,121.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.1,32.5 47,32.5 50.8,5.6 18.9,5.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,145.5 30.3,145.5 44.5,44.2 14.2,44.2  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg);
export default __webpack_public_path__ + "static/media/logo-svg.74b1bdb33bade661285d0df180563673.svg";
export { ForwardRef as ReactComponent };